/**
 * @generated SignedSource<<21c891825195695bcef07d08c167f130>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ImageUploadButtonQuery$variables = {
  contentType?: string | null;
};
export type ImageUploadButtonQuery$data = {
  readonly imageUploadUrl: {
    readonly publicUrl: string | null;
    readonly uploadUrl: string | null;
  } | null;
};
export type ImageUploadButtonQuery = {
  response: ImageUploadButtonQuery$data;
  variables: ImageUploadButtonQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentType"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "contentType",
        "variableName": "contentType"
      }
    ],
    "concreteType": "ImageUploadUrl",
    "kind": "LinkedField",
    "name": "imageUploadUrl",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "publicUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uploadUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImageUploadButtonQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImageUploadButtonQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "53c762d267658cba7a90fce74717269a",
    "id": null,
    "metadata": {},
    "name": "ImageUploadButtonQuery",
    "operationKind": "query",
    "text": "query ImageUploadButtonQuery(\n  $contentType: String\n) {\n  imageUploadUrl(contentType: $contentType) {\n    publicUrl\n    uploadUrl\n  }\n}\n"
  }
};
})();

(node as any).hash = "a4cf3450407a557b294281d0c98d24b0";

export default node;
